<template>
  <ul v-if="errors" class="form-errors">
    <li v-for="error in errors" class="h5 form-errors__item">
      {{ error }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'form-errors',
  props: {
    errors: { type: Array, default: () => [] },
  },
};
</script>
